export default "__VITE_ASSET__78ce3862__"